
import React from 'react';
import './OfflineWalkthroughData.scss';
import '../../Select/Select.scss';
import classNames from 'classnames';
const CustomSelect = ({ onChange, value, options, placeholder, disabled, simplifiedMobileWalkThrough,noOption }) =>
    <select
        defaultValue=""
        className={
            classNames(
                'offlineWalkthroughData__selectItem',
                {
                    'offlineWalkthroughData__selectItem--padded':simplifiedMobileWalkThrough === true
                }
            )
        }
        onChange={(e) => onChange(e)}
        value={value}
        disabled={disabled}
    >
        <option className="select__option" value="" disabled>{placeholder}</option>
        {noOption?null:options.map((s, i) => (
            <option className="select__option" key={i} value={s.id}>{s.name}</option>
        ))}
    </select>


export default CustomSelect;